// extracted by mini-css-extract-plugin
export var btn = "MobileCard-module--btn--b159d";
export var contentContainer = "MobileCard-module--contentContainer--8427f";
export var flex = "MobileCard-module--flex--e65e9";
export var heading = "MobileCard-module--heading--6226e";
export var headingContainer = "MobileCard-module--headingContainer--7f8c2";
export var hero = "MobileCard-module--hero--a2aa2";
export var heroLink = "MobileCard-module--heroLink--4ef5a";
export var highlight = "MobileCard-module--highlight--22f1b";
export var icon = "MobileCard-module--icon--e5463";
export var image = "MobileCard-module--image--7e620";
export var imageWrapper = "MobileCard-module--imageWrapper--8d911";
export var link = "MobileCard-module--link--27ce3";
export var linkText = "MobileCard-module--linkText--b0f85";
export var primary = "MobileCard-module--primary--09c7c";
export var slot = "MobileCard-module--slot--59446";
export var subheading = "MobileCard-module--subheading--0fff1";
export var wedding = "MobileCard-module--wedding--3859a";